import { ForwardedRef, forwardRef } from 'react'

import MediaImage, { MediaImageParams, MediaImageProps } from './MediaImage'
import MediaPlayer, { MediaPlayerHandler } from './MediaPlayer'
import MediaVideo, { MediaVideoParams, MediaVideoProps } from './MediaVideo'

export type MediaParams = {
  use_video: boolean
  image: MediaImageParams
  video: MediaVideoParams
}

export type MediaProps = (MediaImageProps | MediaVideoProps) & MediaParams
export type MediaRef = HTMLImageElement | HTMLVideoElement | MediaPlayerHandler

const needsPlayer = (video: MediaVideoParams) => {
  return video.video_provider === 'youtube' || video.video_provider === 'vimeo' || video.controls
}

const Media = forwardRef<MediaRef, MediaProps>(({ use_video, image, video, ...props }, ref) => {
  return (
    <>
      {use_video ? (
        needsPlayer(video) ? (
          <MediaPlayer
            ref={ref as ForwardedRef<MediaPlayerHandler>}
            {...(props as MediaVideoProps)}
            {...video}
          />
        ) : (
          <MediaVideo
            ref={ref as ForwardedRef<HTMLVideoElement>}
            {...(props as MediaVideoProps)}
            {...video}
          />
        )
      ) : (
        <MediaImage
          ref={ref as ForwardedRef<HTMLImageElement>}
          {...(props as MediaImageProps)}
          {...image}
        />
      )}
      {/* <p className="mt-2 text-small capitalize">
        <span className="block">{`Use video: ${use_video}`}</span>
        <span className="block">{`Provider: ${video.video_provider}`}</span>
        <span className="block">{`Autoplay: ${video.autoplay}`}</span>
        <span className="block">{`Controls: ${video.controls} ${
          video.video_provider === 'youtube' || video.video_provider === 'vimeo' ? '(auto)' : ''
        }`}</span>
      </p> */}
    </>
  )
})

export default Media
